pos-image {
  --max-width: 100%;
}
